import _extends from "../../../@babel/runtime/helpers/esm/extends.js";
import { isHostComponent } from "./isHostComponent.js";
function appendOwnerState(elementType, otherProps, ownerState) {
  return elementType === void 0 || isHostComponent(elementType) ? otherProps : _extends({}, otherProps, {
    ownerState: _extends({}, otherProps.ownerState, ownerState)
  });
}
export {
  appendOwnerState
};
//# sourceMappingURL=appendOwnerState.js.map
